import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-online-query',
  templateUrl: './online-query.component.html',
  styleUrls: ['./online-query.component.scss']
})
export class OnlineQueryComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
